<div class="drag-scroll-content" (dragstart)="onDragStart($event)" #contentRef>
  <ng-content></ng-content>
</div>